const keys = {
  garage: {
    helper: {
      hasLivingSpace: 'Garage with living space is heated and has bathroom and/or kitchen area.',
    },
    titles: {
      hasLivingSpace: 'Is the garage a living space?',
      numberOfCars: 'How many cars fit in the garage?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
